export default "__VITE_ASSET__DhQEuDBm__"